// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"343":"6edf0643","489":"8187f03c"}[chunkId] || chunkId) + "." + {"14":"77ee04bab9d87863","45":"4d694f6cc264164b","343":"70d1d1662963b6c8","420":"1f51f60b4e0e58d1","485":"ae2aa19376d63bc4","489":"8abc39f253bfe7c1","951":"035412b7fddd2989"}[chunkId] + ".js";
};